import { Link } from '@tanstack/react-router'

import { Button } from '@/components'

export const TrialRefused = () => (
  <div role="alert" className="flex flex-col gap-4">
    <h1 className="text-2xl font-semibold tracking-tight">
      This card already started a trial
    </h1>
    <p className="text-[15px] text-muted-foreground">
      Each card gets one free trial. Your account is kept. Pick a plan to
      continue.
    </p>
    <Button size="lg" className="w-full" asChild>
      <Link to="/">See plans</Link>
    </Button>
  </div>
)
